export interface IDashboardMessage {
  message: any;
  is_seen: boolean;
  is_confirmed: boolean;
}

export class State {
  dashboardMessages: Array<IDashboardMessage> = [];
}
